module.exports = __webpack_public_path__ + "static/media/edconnect-logo.3798612b.png";